import React from 'react';
import {IndexRoute, Route} from 'react-router';

import * as Cookie from 'js-cookie';
import hoistNonReactStatics from 'hoist-non-react-statics';

import Authorize from '../containers/auth/Authorize';

import App from '../containers/app/App';
import MainPage from '../containers/mainPage/MainPage';
import ContentPage from '../containers/contentPage/ContentPage';
import CategoryPage from '../containers/categoryPage/CategoryPage';
import ProductPage from '../containers/productPage/ProductPage';
import ProfilePage from '../containers/profilePage/ProfilePage';
import ProfileGeneral from '../containers/profilePage/ProfileGeneral';
import ProfileOrders from '../containers/profilePage/ProfileOrders';
import OAuthHandlerPage from '../containers/auth/pages/OAuthHandlerPage';
import EmailVerificationPage from '../containers/auth/pages/EmailVerificationPage';
import CheckoutPage from '../containers/checkoutPage/CheckoutPage';
import OrderPage from '../containers/orderPage/OrderPage';
import ReviewPage from '../containers/reviewPage/ReviewPage';
import AffiliatePage from '../containers/affiliatePage/AffiliatePage';
import SpecialOrderPage from '../containers/specialOrderPage/SpecialOrderPage';
import ResetPasswordPage from '../containers/auth/pages/ResetPasswordPage';
import ReviewsPage from '../containers/reviewsPage/ReviewsPage';
import HowItWorksPage from '../containers/howItWorksPage/HowItWorksPage';
import SearchPage from '../containers/searchPage/SearchPage';
import ErrorPage from '../containers/errorPage/ErrorPage';
import WorkWithUsPage from "../containers/workWithUsPage/WorkWithUsPage";

import {prefixByChannel} from './prefixes';

const ProtectedCategory = (WrappedComponent) => {
  const NotExcludedByCountry = ({params, ...rest}) => {
    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      if (excludedTaxons.includes(params.splat)) {
        return <ErrorPage />;
      } else {
        return <WrappedComponent params={params} {...rest} />;
      }
    } else {
      return <WrappedComponent params={params} {...rest} />;
    }
  }

  hoistNonReactStatics(NotExcludedByCountry, WrappedComponent);

  NotExcludedByCountry.WrappedComponent = WrappedComponent;
  NotExcludedByCountry.displayName = `NotExcludedByCountry(${WrappedComponent.displayName})`;

  return NotExcludedByCountry;
}

const buildRoutes = (prefix, children) => (
  <Route key={prefix} path={prefix}>
    <IndexRoute component={MainPage}/>

    <Route path="r/**" component={AffiliatePage}/>

    <Route path="auth">
      <Route path="oauth-claim" component={OAuthHandlerPage}/>
      <Route path="reset-password/:userId/:token" component={ResetPasswordPage}/>
      <Route path="verify-email/:userId/:token" component={EmailVerificationPage}/>
    </Route>

    <Route path="profile" component={Authorize(ProfilePage)}>
      <IndexRoute component={ProfileGeneral}/>
      <Route path="orders" component={ProfileOrders}/>
    </Route>

    <Route path="checkout" component={CheckoutPage}/>
    <Route path="order/:orderToken/review" component={ReviewPage}/>
    <Route path="order/:orderId/:orderToken" component={OrderPage}/>
    <Route path="quick-order/:cartId/:cartToken" components={SpecialOrderPage}/>

    <Route path="work-with-us" component={WorkWithUsPage}/>
    <Route path="how-it-works" component={HowItWorksPage}/>

    <Route path="reviews" component={ReviewsPage}/>

    <Route path="page/**" component={ContentPage}/>
    <Route path="service/**" component={ProductPage}/>

    <Route path="search" component={SearchPage}/>

    {children}

    <Route path="**" component={ProtectedCategory(CategoryPage)}/>
  </Route>
);

export default (
  <Route component={App}>
    {buildRoutes(
      '/',
      Object.values(prefixByChannel).map(prefix => buildRoutes(prefix, null))
    )}
  </Route>
);



// WEBPACK FOOTER //
// ./routes/routes.js